import { render, staticRenderFns } from "./scenePsg.vue?vue&type=template&id=2a506218&scoped=true&"
import script from "./scenePsg.vue?vue&type=script&lang=js&"
export * from "./scenePsg.vue?vue&type=script&lang=js&"
import style0 from "./scenePsg.vue?vue&type=style&index=0&id=2a506218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a506218",
  null
  
)

export default component.exports